import styled from "styled-components";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const CRITERIA = [
  {
    id: "minLength",
    label: "Pelo menos 6 caracteres",
    test: (value: string) => value.length >= 6,
  },
  {
    id: "uppercase",
    label: "Uma letra maiúscula",
    test: (value: string) => /[A-Z]/.test(value),
  },
  {
    id: "lowercase",
    label: "Uma letra minúscula",
    test: (value: string) => /[a-z]/.test(value),
  },
  {
    id: "special",
    label: "Um caractere especial",
    test: (value: string) => /[\W_]/.test(value),
  },
  {
    id: "noSequential",
    label: "Não conter números sequenciais",
    test: (value: string) =>
      !/(012|123|234|345|456|567|678|789|890)/.test(value),
  },
];

const ChecklistWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
  padding: 12px;
  border: 1px solid #e7e8ec;
  border-radius: 8px;
  margin-top: 8px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const CriterionItem = styled.div<{ $met: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-family: "Noto Sans", sans-serif;
  font-size: 12px;
  line-height: 140%;
  color: ${({ $met }) => ($met ? "#01ab7d" : "#667085")};

  svg {
    font-size: 16px;
    flex-shrink: 0;
    margin-top: 1px;
    color: ${({ $met }) => ($met ? "#01ab7d" : "#c4c4c4")};
  }
`;

interface PasswordCriteriaChecklistProps {
  password: string;
}

export default function PasswordCriteriaChecklist({
  password,
}: PasswordCriteriaChecklistProps) {
  if (!password) {
    return null;
  }

  return (
    <ChecklistWrapper>
      {CRITERIA.map(criterion => {
        const met = criterion.test(password);
        return (
          <CriterionItem key={criterion.id} $met={met}>
            {met ? (
              <CheckBoxIcon fontSize="small" />
            ) : (
              <CheckBoxOutlineBlankIcon fontSize="small" />
            )}
            <span>{criterion.label}</span>
          </CriterionItem>
        );
      })}
    </ChecklistWrapper>
  );
}
